<template>
  <v-container fluid class="pa-0 wrapper" :style="maxHeight + ' ' + minHeight">
    <div v-if="!loading" :class="['top', horizontal ? 'horizontal' : '', 'shadow', showTopShaddow ? 'visible' : '']" />
    <v-list v-scroll.self="handleScroll" :class="[horizontal ? 'horizontal' : '', listclass]"
      class="py-0 lista OddMarkedList" :style="maxHeight + ' ' + minHeight" ref="thelist" dense>
      <slot>

        <slot name="prepend-item" />

        <template v-if="limitedList && limitedList.length > 0 && loading === false">
          <!-- Grouped mode -->
          <template v-if="groupedLimitedList && groupedLimitedList.length">
            <template v-for="(g1, g1Index) in groupedLimitedList">
              <!-- Level 1 header -->
              <slot name="group-header" :group="g1.group" :items="g1.items">
                <GenericListSubHeader :text="g1.group" :sticky="true" />
              </slot>

              <!-- If two-level: g1.items are subgroups -->
              <template v-if="g1.items.length && g1.items[0] && g1.items[0].items">
                <template v-for="(g2, g2Index) in g1.items">
                  <slot name="subgroup-header" :group="g2.group" :items="g2.items" :parentIndex="g1Index">
                    <!-- You could style this differently (indent, smaller, etc.) -->
                    <GenericListSubHeader :text="g2.group" :sticky="false" />
                  </slot>

                  <template v-for="(item, index) in g2.items">
                    <slot name="list-item" :item="item" :index="index" :groupIndex="g1Index" :subgroupIndex="g2Index"
                      :handleclicked="handleclicked">
                      <v-list-item @click="handleclicked(item)">
                        item {{ index }}
                      </v-list-item>
                    </slot>
                  </template>
                </template>
              </template>

              <!-- Else: one-level (backward compatible) -->
              <template v-else>
                <template v-for="(item, index) in g1.items">
                  <slot name="list-item" :item="item" :index="index" :groupIndex="g1Index"
                    :handleclicked="handleclicked">
                    <v-list-item @click="handleclicked(item)">
                      item {{ index }}
                    </v-list-item>
                  </slot>
                </template>
              </template>

              <!-- Group footer (customizable via slot, default hidden) -->
              <slot name="group-footer" :group="g1.group" :items="g1.items" />
            </template>
          </template>
          <!-- Flat mode (no groupBy) -->
          <template v-else>
            <template v-for="(item, index) in limitedList">
              <slot name="list-item" :item="item" :index="index" :group-index="0" :handleclicked="handleclicked">
                <v-list-item @click="handleclicked(item)">
                  item {{ index }}
                </v-list-item>
              </slot>
            </template>
          </template>
        </template>

        <template v-else-if="loading === true" fluid class="pa-0">
          <template v-if="skeletonloading">
            <slot name="skeleton-loader" v-for="index in 10" :index="index">
              <v-skeleton-loader type="list-item" :style="'opacity:' + (1 / (index - 1)) + ';'"></v-skeleton-loader>
            </slot>
          </template>
          <centered-loading v-else :displayBool="true" :completedBool="false"
            :displayText="$t('servicesystem.common_objects.commonterms.loading_placeholder', { pkey: $t('servicesystem.common_objects.commonterms.items').toLowerCase() })"
            class="ignoreodd">
          </centered-loading>
        </template>

        <template v-else-if="loading === false">
          <slot v-if="list && unfilteredcount" name="empty-filtered-list">
            <empty-page :icon="'mdi-filter-remove'"
              :title="$t('servicesystem.common_objects.fallbackterms.empty_filter', { okey: $t('servicesystem.common_objects.commonterms.items').toLowerCase() })"
              :message="$t('servicesystem.common_objects.fallbackterms.empty_filter_body')" class="ignoreodd">
              <template v-slot:actions>
                <slot name="empty-filtered-list-actions" />
              </template>
            </empty-page>
          </slot>

          <slot v-else name="empty-list">
            <empty-page :icon="'mdi-clipboard-alert'" :title="$t('servicesystem.common_objects.fallbackterms.no_items')"
              :message="$t('servicesystem.common_objects.fallbackterms.found_no_items')" class="ignoreodd">
              <template v-slot:actions>
                <slot name="empty-list-actions" />
              </template>
            </empty-page>
          </slot>
        </template>

        <slot name="append-item" />

      </slot>
      <div v-if="paginationLimitNotReached && limitedList && limitedList.length">
        <template v-if="skeletonloading">
          <slot name="skeleton-loader" v-for="index in 4" :index="index">
            <v-skeleton-loader type="list-item" :style="'opacity:' + (1 / index) + ';'"></v-skeleton-loader>
          </slot>
        </template>
        <centered-loading v-else :displayBool="true" :completedBool="false"
          :displayText="$t('servicesystem.common_objects.commonterms.loading_placeholder', { pkey: $t('servicesystem.common_objects.commonterms.items').toLowerCase() })"
          class="ignoreodd">
        </centered-loading>
      </div>
    </v-list>
    <div v-if="!loading"
      :class="['bottom', horizontal ? 'horizontal' : '', 'shadow', showBottomShaddow ? 'visible' : '']" />
  </v-container>
</template>


<script>
import CenteredLoading from "@/components/Sections/CenteredLoading.vue";
import EmptyPage from "@/components/Sections/EmptyPage.vue";
import { debounce } from "debounce";
import GenericListSubHeader from "@/components/ListItems/GenericListSubHeader.vue";

export default {
  name: "QScroll",
  props: {
    height: [String, Number],
    minheight: [String, Number],
    list: Array,
    unfilteredcount: Number,
    horizontal: Boolean,
    listclass: String,
    loading: Boolean,
    skeletonloading: Boolean,
    handleclicked: Function,
    pagination: Object, //{itemsPerPage: 50, nextPageLoading: false, maxItemCount: 200}
    initLimit: {
      type: Number,
      default: 50,
    },
    scrollcheckTrigger: Number,
    /**
    * Grouping:
    * - function(item) => groupKey
    * - string path like 'status' or 'meta.category'
    * - OR an array of the above for 2-level grouping: [primary, secondary]
    */
    groupBy: [Function, String, Array],
    /** Optional: custom sort for groups (a,b)=>number */
    groupSort: Function,           // level 1 sort
    /** Optional: sort within each group (a,b)=>number */
    groupItemSort: Function,       // leaf items sort (when 1-level) or items inside level 2
    /** Optional: sort for level 2 groups (a,b)=>number */
    subgroupSort: Function,
  },
  components: {
    EmptyPage,
    CenteredLoading,
    GenericListSubHeader,
  },
  mixins: [],

  data() {
    return {
      showTopShaddow: false,
      showBottomShaddow: false,
      renderMoreOnPercent: 90,
      page: 1,
      listChangeTrigger: 0,
      limit: 50,
    };
  },

  created() {
    this.limit = this.initLimit;
  },

  mounted() {
    var is = this.isOverflowing();
    this.showBottomShaddow = is;
    if (!is) {
      this.limit = this.limit * 2;
      this.showBottomShaddow = this.isOverflowing();
    }
  },

  methods: {
    getByPath(obj, path) {
      if (!path) return undefined;
      return path.split('.').reduce((o, k) => (o ? o[k] : undefined), obj);
    },

    resolveGroupKey(item, by) {
      if (typeof by === 'function') return by(item);
      if (typeof by === 'string') return this.getByPath(item, by);
      return undefined;
    },

    normalizeKey(objOrPrim) {
      if (objOrPrim && typeof objOrPrim === 'object') {
        // Prefer stable Id if present, else JSON fallback
        if ('Id' in objOrPrim) return `obj:${objOrPrim.Id}`;
        return `obj:${JSON.stringify(objOrPrim)}`;
      }
      return String(objOrPrim);
    },

    handleScroll(e) {
      var position = this.horizontal ? e.target.scrollLeft : e.target.scrollTop;
      var offset = this.horizontal ? e.target.offsetWidth : e.target.offsetHeight;
      //var clienth = e.target.clientHeight;
      var bottom = this.horizontal ? e.target.scrollWidth : e.target.scrollHeight;
      this.showTopShaddow = position != 0 /*&& bottom > clienth*/;
      var scrollpercent = Math.round(((position + offset) / bottom) * 100);

      //console.log("scrollpercent", scrollpercent, "position", position, 'limit', this.limit);
      if (scrollpercent > this.renderMoreOnPercent) {

        if (this.list && this.limit < this.list.length) {
          this.limit = this.limit + 1;
        }
        this.$emit("limitincrease", this.limit);

        //this.debounceEmit({ emitKey: 'limitincrease', value: this.limit });

        if (this.paginationLimitNotReached) {
          var loadeditems = this.pagination.page * this.pagination.itemsPerPage;
          var lessThanHalfPageLeft = ((this.limitedList && this.limitedList.length) || 0) > (loadeditems - (this.pagination.itemsPerPage * 0.5))
          if (lessThanHalfPageLeft) {
            this.debounceEmit({ emitKey: 'loadNextPage' });
          }
        }
      }
      this.showBottomShaddow = position + offset != bottom;
    },

    validateOverflow() {
      this.showBottomShaddow = this.isOverflowing();
    },

    isOverflowing() {
      var is;
      if (this.$refs.thelist) {
        var element = this.$refs.thelist.$el;
        if (this.horizontal) {
          is = element.offsetWidth < element.scrollWidth;
        } else {
          is = element.offsetHeight < element.scrollHeight;
        }
      }
      return is;
    },

    debounceEmit: debounce(function ({ emitKey, value }) {
      this.$emit(emitKey, value);
    }, 700),
  },

  computed: {
    limitedList() {
      var maxlimit = (this.pagination && ((this.pagination.page + 1) * this.pagination.itemsPerPage)) || this.limit;
      return (this.list && this.list.length > 0) ? this.list.take(maxlimit) : this.list;
    },

    groupedLimitedList() {
      const src = this.limitedList;
      if (!this.groupBy || !src || !src.length) return null;

      // Support 1 or 2 levels
      const levels = Array.isArray(this.groupBy) ? this.groupBy.slice(0, 2) : [this.groupBy];

      // 1) Build level 1 groups
      const g1Map = new Map();
      for (const it of src) {
        const g1Obj = this.resolveGroupKey(it, levels[0]);
        const g1Key = this.normalizeKey(g1Obj);
        if (!g1Map.has(g1Key)) {
          g1Map.set(g1Key, { key: g1Key, group: g1Obj, items: [] });
        }
        g1Map.get(g1Key).items.push(it);
      }

      let groups = Array.from(g1Map.values());

      // 2) If level 2 provided, split each level 1 into level 2 subgroups
      const hasLevel2 = levels.length === 2;
      if (hasLevel2) {
        groups.forEach(g1 => {
          const g2Map = new Map();
          for (const it of g1.items) {
            const g2Obj = this.resolveGroupKey(it, levels[1]);
            const g2Key = this.normalizeKey(g2Obj);
            if (!g2Map.has(g2Key)) {
              g2Map.set(g2Key, { key: g2Key, group: g2Obj, items: [] });
            }
            g2Map.get(g2Key).items.push(it);
          }
          let subgroups = Array.from(g2Map.values());

          // sort level 2 groups if provided
          if (this.subgroupSort) {
            subgroups.sort((a, b) => this.subgroupSort(a.group, b.group));
          }

          // sort leaf items inside each level 2
          if (this.groupItemSort) {
            subgroups.forEach(sg => sg.items.sort(this.groupItemSort));
          }

          // replace items with subgroups
          g1.items = subgroups;
        });
      } else {
        // 1-level: optional sort of leaf items
        if (this.groupItemSort) {
          groups.forEach(g => g.items.sort(this.groupItemSort));
        }
      }

      // sort level 1 groups if provided
      if (this.groupSort) {
        groups.sort((a, b) => this.groupSort(a.group, b.group));
      }

      return groups;
    },

    paginationLimitNotReached() {
      var result = this.pagination && !this.pagination.partialPageReached
      return result;
    },

    maxHeight() {
      var limit = this.height;
      if (typeof limit === "string" || limit instanceof String) {
        return "max-height: " + limit + ";";
      } else if (limit) {
        return "max-height: " + limit + "px;";
      } else {
        return "";
      }
    },

    minHeight() {
      var limit = this.minheight;
      if (typeof limit === "string" || limit instanceof String) {
        return "min-height: " + limit + ";";
      } else if (limit) {
        return "min-height: " + limit + "px;";
      } else {
        return "";
      }
    },
  },

  watch: {
    list: function () {
      this.listChangeTrigger++;
      setTimeout(() => this.validateOverflow(), 200);
    },

    scrollcheckTrigger: function () {
      //console.log("scrollcheckTrigger changed, validating overflow");
      // run after DOM updates
      this.$nextTick(() => {
        const el = this.$refs.thelist && this.$refs.thelist.$el;
        if (el) this.handleScroll({ target: el });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.lista {
  overflow-y: overlay;
  z-index: 10;
}

.horizontal {
  display: flex;
  flex-direction: row;
  overflow-y: none;
  overflow-x: overlay;
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .lista {
    overflow-y: auto;
  }

  .horizontal {
    overflow-y: none;
    overflow-x: auto;
  }
}

.wrapper {
  position: relative;
  overflow: hidden;
}

.shadow {
  position: absolute;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 10px;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}

.horizontal.shadow {
  position: absolute;
  top: 0;
  z-index: 3;
  width: 15px;
  height: 100%;
  opacity: 0;
}

.shadow.visible {
  visibility: visible;
  opacity: 1;
}

.top.shadow {
  top: 0;
  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 0.15), transparent);
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.15), transparent);
}

.top.horizontal.shadow {
  left: 0 !important;
  right: auto;
  background: -webkit-linear-gradient(90deg, rgba(0, 0, 0, 0.25), transparent);
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.25), transparent);
}

.bottom.shadow {
  bottom: 0;
  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, 0.25), transparent);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.25), transparent);
}

.bottom.horizontal.shadow {
  left: auto;
  right: 0 !important;
  background: -webkit-linear-gradient(270deg, rgba(0, 0, 0, 0.25), transparent);
  background: linear-gradient(270deg, rgba(0, 0, 0, 0.25), transparent);
}

.theme--light.v-sheet {
  background-color: transparent;
}
</style>